import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-20 px-4 bg-white relative" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-41">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-dark mb-8 leading-tight" data-id="element-42">
            ¿Te has sentido{' '}
            <span className="text-urgency italic" data-id="element-43">traicionada</span> por tu
            propio cuerpo últimamente?
          </h2>

          <div className="space-y-6 text-lg text-dark-light leading-relaxed" data-id="element-44">
            <p data-id="element-45">
              Te levantas cansada, tu ropa favorita ya no te cierra y, a pesar
              de comer solo ensaladas, esa grasa abdominal parece haberse mudado
              a vivir contigo de forma permanente.
            </p>
            <p className="font-medium text-dark text-xl p-6 bg-cream rounded-2xl border border-sage/20 shadow-sm" data-id="element-46">
              No es tu falta de voluntad. No es que estés "vieja".
              <br data-id="element-47" />
              <span className="text-sage-dark block mt-2" data-id="element-48">
                Es que tus hormonas están enviando las señales equivocadas.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}